import { ReactElement } from "react";

import { OptOutListPage } from "~frontend/components/optouts/OptOutListPage";

export const OptOuts = (): ReactElement => <OptOutListPage />;
